const tech_img = require('../../assets/img/tutorials/sentimiento/tech.png');
const secondary_tech_img = require('../../assets/img/tutorials/sentimiento/secondary-tech.png');
const func_img = require('../../assets/img/tutorials/sentimiento/func.png');
const secondary_func_img = require('../../assets/img/tutorials/sentimiento/secondary-func.png');

export const SentimientoSteps = [
    {
        name: 'Sentimiento del ciudadano',
        title: 'Descripción funcional',
        description: <span>
            <p>El gemelo digital puede permitir <b>implementar un sistema de monitorización del sentimiento del ciudadano en los diferentes distritos de Madrid</b>, con el objetivo de evaluar la percepción pública sobre diversos aspectos urbanos como las zonas verdes, la delincuencia, la gestión de residuos, así como otros servicios municipales.
            </p>
            <p>Estos datos permiten a las autoridades <b>entender mejor las necesidades y prioridades de la población</b>, facilitando una gestión más eficaz y alineada con las expectativas ciudadanas.
            </p>
            <p>Las alertas automatizadas informan a los responsables políticos sobre <b>cambios significativos en el sentimiento ciudadano</b>, permitiéndoles responder de manera proactiva

            </p>
        </span>,
        secondarydescription: <span>
            <p>Área de Gobierno de Vicealcaldía, Portavoz, Seguridad  y Emergencias</p>
        </span>,
        mainimage: <img src={func_img} alt="main_func" />,
        secondaryimage: <img src={secondary_func_img} alt="sec_func" />,
    },
    {
        name: 'Sentimiento del ciudadano',
        title: 'Descripción técnica',
        description: <div>
            <span>
                Integraciones técnicas
                <ul>
                    <li><b>Integración de Cartografía 2D y 3D</b>, permitiendo una representación detallada del espacio urbano y la interpretación de patrones geoespaciales.</li>
                    <li><b>Integración de Datos mediante API</b>, lo que permite la importación automática y la sincronización de datos de fuentes externas, asegurando un flujo de datos constante y actualizado para el análisis y la toma de decisiones.</li>
                </ul>
            </span>
            <span>
                Origen de Datos
                <ul>
                    <li>Fuente de datos para calcular el <b>Índice de Vulnerabilidad Territorial Agregado (IVTA)</b>. Este sistema identifica zonas vulnerables dentro de los distritos y barrios, orientando la gestión municipal y permitiendo un diagnóstico preciso de los datos.</li>
                </ul>
            </span>


        </div>,
        mainimage: <img src={tech_img} alt="main_tech" />,
        secondaryimage: <img src={secondary_tech_img} alt="sec_tech" />,
    }
];